import { useEffect, useRef } from "react";
import { useWorklistSocketStore } from "@/stores/worklist-socket";
/**
 * Registers a handler for a single socket action for the lifetime of the calling
 * component. The handler is kept in a ref so callers need not memoise it.
 */
export function useSocketEvent(action, handler) {
  var addListener = useWorklistSocketStore(function (s) {
    return s.addListener;
  });
  var removeListener = useWorklistSocketStore(function (s) {
    return s.removeListener;
  });
  var handlerRef = useRef(handler);
  handlerRef.current = handler;
  useEffect(function () {
    var stable = function stable(message) {
      return handlerRef.current(message);
    };
    addListener(action, stable);
    return function () {
      return removeListener(action, stable);
    };
  }, [action, addListener, removeListener]);
}